import translations from './translations'

translations.add('pt', {
    header: 'Doar a uma instituição de caridade?',
    donate: 'Doar',
    thanks: 'Obrigado pela sua doação!'
})
